namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SpisovyPlanInport extends GContentBase {
        private form: JQuery<HTMLElement>;
        // 27.06.2022 - TFeik
        // Změna na SSL.
        private registerClass: string = 'Gordic.Ssl.Server.GImportSpisPlanAsync';//"Gordic.AdmIsl.Server.ImportSpisPlanAsync"

        importSpisPlan() {
            if (this.form.gform("isValid")) {
                var inputImportObj/*: Gordic.Ssl.Interface.GInputImportSpisPlanDto*/ = {
                    file: this.form.findFields("spisPlanXml").gfield("getValue")[0],
                    separator: this.form.findFields("separator").gfield("getValue"),
                    spis_pl: this.form.findFields("spis_pl").gfield("getValue"),
                    nazev: this.form.findFields("nazev").gfield("getValue")
                }
                Async.GTaskManager.start(this.registerClass, inputImportObj, { clearOnFinish: true, autoClean: true })
                this.close();
            }
        }

        onContentReady() {
            this.init();
            this.initAsyncTask();
        }

        private init() {
            this.createForm();
        }

        private createForm() {
            var form = new Gordic.Forms.Form({ layoutDescriptor: "L1M1S1" })
                .addRow("jres:33000034").addField("gfilefield", { //RC 33000034 : Soubor spisového plánu
                    name: "spisPlanXml",
                    acceptExtension: ".xml",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required"
                })
                .addRow("jres:33000035").addField("gstringbox", { //RC 33000035 : Oddělovač
                    name: "separator",
                    validators: [new Gordic.Validators.Required({ stopping: true })],
                    flag: "required"
                })
                .addRow("jres:33000838").addField("gstringbox", Gordic.Prefabs.Field.charCounter(5), { //RC 33000838 : Vlastní identifikátor
                    name: "spis_pl",
                    validators: [new Gordic.Validators.Length({ stopping: true, min: 0, max: 5 })],
                    
                }) 
                .addRow("jres:33000839").addField("gstringbox", Gordic.Prefabs.Field.charCounter(50), { //RC 33000839 : Název spisového plánu
                    name: "nazev",
                    validators: [new Gordic.Validators.Length({ stopping: true, min: 0, max: 50 })]
                }) 

            this.form = $("<div>").appendTo(this.element).gform("createFrom", form);
        }

        private initAsyncTask() {
            if (Async.GTaskManager.getAllTasks().find(item => item.className == this.registerClass) == undefined) {
                Async.GTaskManager.on("init", this.registerClass, function (o) {
                    var currentDate = new Date();
                    var importNotId = "adm-import-{0}{1}{2}".format(currentDate.getHours(), currentDate.getMinutes(), currentDate.getSeconds());
                    var notif: IGNotificationOptions = {
                        id: importNotId,
                        title: "jres:32131121",
                        icon: "fa-info-circle",
                        content: "jres:33000037" //RC 33000037 : Probíhá import spisového plánu
                    }
                    var not = new GObservableObject(notif);
                    this.customDto = { not: not, id: importNotId };
                    $.content($("#main")).notification("add", notif, true);
                })
                Async.GTaskManager.on("always", this.registerClass, function (o) {
                    this.customDto = {};
                    $.content($("#main")).notification("remove", this.customDto.id);
                    this.clean();
                })
                Async.GTaskManager.on("fail", this.registerClass, function (o) {
                    $.content($("#main")).notification("remove", this.customDto.id);
                    this.customDto = {};
                    var notifError: IGNotificationOptions = {
                        icon: "fa-exclamation-circle",
                        shortTemplate: "<b>jres:33000038</b>", //RC 33000038 : Chyba při importu spisového plánu.
                        content: {},
                        state: "error",
                    }
                    $.content($("#main")).notification("add", notifError, true);
                    this.clean();
                })
                Async.GTaskManager.on("done", this.registerClass, function (o) {
                    var result = o.result as string;
                    if (result) {
                        $.content($("#main")).notification("remove", this.customDto.id);
                        var currentDate = new Date();
                        var id = "spis-pl-success-{0}{1}{2}".format(currentDate.getHours(), currentDate.getMinutes(), currentDate.getSeconds());
                        var cnt = $.content($("#main"));
                        var notifOk: IGNotificationOptions = {
                            id: id,
                            icon: "fa-check-circle",
                            shortTemplate: "<b>jres:33000039</b><br /><span>jres:33000040: {0}</span>".format(result),  //RC 33000040 : ID spisového plánu
                            content: {},
                            state: "success"
                        }
                        cnt.notification("add", notifOk, true);
                    }
                })
            }
        }
    }
}